exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.version[data-v-4d3a6a2e] {\n    color: #808080;\n    font-family: HankenGroteskRegular, HankenGroteskRegularOld, HelveticaNeue, Helvetica, Arial, sans-serif;\n    font-size: 14px;\n    margin: 15px 5px;\n    text-align: right;\n}\n\n", ""]);

// exports
